<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Home",
  computed: {
    ...mapState({
      // arrow functions can make the code very succinct!
      searchActive: state => state.searchActive
    })
  }
};
</script>

<style lang="scss"></style>
